/* eslint-disable */
import { throttle } from 'lodash'
import { shopList } from '@services/admin.service'
export default {
  data() {
    return {
      isLoading: true,
      svgWrapper: null,
      svgEl: null,
      polygons: [],
      pavilions: [],
      coordinates: [],
      tableRows: [],
      currentFloor: {},
      shops: [],
    }
  },
  methods: {
    async getShopList() {
      return shopList.execute({}).then(res => {
        const { data } = res
        const { items } = data
        this.shops = items.sort(
          (a, b) => a.title.localeCompare(b.title)
        )
        if (this.initActions) {
          this.initActions()
        }
      })
    },

    findPavilion(pavilions, polygonId) {
      return pavilions.find(el => {
        if (el.mapKey === polygonId) return el
      })
    },

    setLabelForAllPavilions(polygonId, polygon) {
      if (this.currentFloor.initialPavilions) {
        const pavilions = this.currentFloor.initialPavilions
        const pavilionInitial = this.findPavilion(pavilions, polygonId)
        
        if (pavilionInitial && pavilionInitial.mapKey === polygonId) {
          this.shops.forEach(shop => {

            if (pavilionInitial.shop &&
              pavilionInitial.shop.label &&
              shop.label === pavilionInitial.shop.label) {

              polygon.setAttribute('label', pavilionInitial.label)

            }

          })
        }
      }
    },

    async createPavilion(trigger) {
      this.pavilions = []
      const CHUNK_SIZE = 10
      return new Promise((resolve, reject) => {
        for (let i = 0; i < this.polygons.length / CHUNK_SIZE; i++) {
          (s => {
            setTimeout(() => {
              const circles = Array.from(this.polygons).slice(s, s + CHUNK_SIZE).map(polygon => {
                const polygonId = polygon.getAttribute('id')

                let obj = {
                  mapKey: polygonId,
                  logoY: 0,
                  logoX: 0,
                  shop: null,
                }

                if (this.currentFloor.pavilions) {

                  const pavilions = this.currentFloor.pavilions
                  const pavilion = this.findPavilion(pavilions, polygonId)

                  this.setLabelForAllPavilions(polygonId, polygon)

                  if (pavilion && pavilion.mapKey === polygonId) {
                    this.shops.forEach(shop => {
                      if (pavilion.shop) {

                        if (pavilion.shop.label &&
                          shop.label === pavilion.shop.label) {

                          obj.shop = pavilion.shop
                          polygon.setAttribute('label', pavilion.label)

                          if (trigger !== 'empty') {
                            polygon.classList.add('is-fill')
                          }

                        }

                        if (shop.label === pavilion.shop) {
                          pavilion.shop = shop
                          obj = pavilion
                        }
                      }
                    })
                  }
                }
                return obj
              })

              this.pavilions = this.pavilions.concat(circles)

              if (i * CHUNK_SIZE + CHUNK_SIZE >= this.polygons.length) {
                resolve()
              }

            }, 1)
          })(i * CHUNK_SIZE)
        }
      })
    },

    highlightPolygon(id, trigger) {
      this.polygons.forEach((polygon, index) => {
        const polygonId = polygon.getAttribute('id')
        if (polygonId === id) {
          polygon.classList.add('is-highlighted', 'is-active')
          const timeout = 100
          setTimeout(() => {
            this.setLogoImage(polygonId, 'logo', trigger)
            this.logoCentering(polygon, index)
          }, timeout)
        }
      })
    },

    unhighlightPolygon(trigger) {
      this.polygons.forEach(polygon => {
        polygon.classList.remove('is-highlighted', 'is-active')
        if (!trigger) {
          polygon.classList.remove('is-fill')
        }
        const polygonId = polygon.getAttribute('id')
        this.setLogoImage(polygonId, 'logoMono')
      })
    },
    getLogoUrl(pavilion, logoKey) {
      return pavilion.shop[logoKey] || pavilion[logoKey]
    },

    setLogoImage(polygonId, logoKey, trigger) {
      let logo = this.$refs[`logo_${polygonId}`]
      if (logo && logo[0]) {

        logo = logo[0]

        const pavilion = this.pavilions.find(el => el.mapKey == polygonId)
        const initialPavilions = this.currentFloor.initialPavilions

        if (pavilion && pavilion.shop) {
          const logoUrl = this.getLogoUrl(pavilion, logoKey)
          logo.setAttribute('src', logoUrl)
          throttle(this.getPolygonCenter, 300)
        } else if ('click' === trigger && initialPavilions) {
          const pavilion = initialPavilions.find(el => el.mapKey == polygonId)
          if (pavilion && pavilion.shop) {
            const logoUrl = this.getLogoUrl(pavilion, logoKey)
            logo.setAttribute('src', logoUrl)
            throttle(this.getPolygonCenter, 300)
          }

        }
      }
    },

    getPolygonCenter(trigger) {
      this.$nextTick(() => {
        this.polygons.forEach((polygon, index) => {
          this.logoCentering(polygon, index, trigger)
        })
      })
    },

    logoCentering(polygon, index, trigger) {
      const polygonId = polygon.getAttribute('id')

      let logo = this.$refs[`logo_${polygonId}`]

      if (logo && logo[0] && this.pavilions[index]) {
        logo = logo[0]

        const logoCentering = () => {
          const two = 2
          const bboxPolygon = polygon.getBoundingClientRect()
          const polygonCenter = {
            x: parseInt(bboxPolygon.left + bboxPolygon.width / two),
            y: parseInt(bboxPolygon.top + bboxPolygon.height / two),
          }

          logo.style.left = 0
          logo.style.top = 0

          const logoHeightOffset = bboxPolygon.height - bboxPolygon.height * 0.5
          const logoWidthOffset = bboxPolygon.width - bboxPolygon.width * 0.5

          logo.style.maxHeight = `${logoHeightOffset}px`
          logo.style.maxWidth = `${logoWidthOffset}px`

          const bboxLogo = logo.getBoundingClientRect()
          const logoXOffset = bboxLogo.left + bboxLogo.width / two
          const logoYOffset = bboxLogo.top + bboxLogo.height / two

          const logoX = parseInt(polygonCenter.x - logoXOffset)
          const logoY = parseInt(polygonCenter.y - logoYOffset)

          const logoMergeCenters = item => {
            const xPercent = bboxPolygon.width * (item.logoX / 100)
            const yPercent = bboxPolygon.height * (item.logoY / 100)

            logo.style.left = `${logoX + xPercent}px`
            logo.style.top = `${logoY + yPercent}px`
          }

          if (this.pavilions[index]) {
            logoMergeCenters(this.pavilions[index])
          }

          if (this.currentFloor && this.currentFloor.pavilions) {
            const pavilion = this.currentFloor.pavilions.find(el => {
              if (el.mapKey === polygonId) return el
            })

            if (pavilion) {
              logoMergeCenters(pavilion)
            }
          }

          this.$nextTick(() => {
            if (trigger !== 'zoom') {
              logo.classList.remove('is-hidden')
            }
          })
        }
        if (logo.complete) {
          logoCentering()
        } else {
          logo.onload = async () => {
            this.$nextTick(() => {
              logoCentering()
            })
          }
        }
      }
    },

  },
}
